<div class="modal-header">
    <h4 class="modal-title ms-3">{{modalTitle}}</h4>
    <button type="button" class="btn-close me-3" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body py-4">
    <div class="container-fluid px-3">
        <div class="alert alert-danger alert-outline-coloured mb-3" *ngIf="errorSaving">
            <div class="alert-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
            </div>
            <div class="alert-message">
                <strong>An error occurred.</strong> Unable to remove the limits for this {{friendlyTextType}}.
            </div>
        </div>        
        <div class="mb-3">
            Do you wish to remove the claim limits for the following {{friendlyTextType}}?
        </div>
        <div class="bg-light rounded-3 px-3 py-2">
            <table class="table table-sm table-no-bottom-border lh-md mb-0">
                <tbody *ngIf="vendor">
                <tr>
                    <th class="text-end text-nowrap">Name</th>
                    <td class="w-65">{{vendor.friendlyName == '' ? vendor.legalName : vendor.friendlyName}}</td>
                </tr>
                <tr>
                    <th class="text-end text-nowrap">ID</th>
                    <td class="w-65">{{vendor.vendorId}}</td>
                </tr>
                <tr>
                    <th class="text-end">Address</th>
                    <td class="w-65">
                        {{vendor.address}}<br>
                        {{vendor.city}}, {{vendor.province}} {{Utils.formatPostalZipCode(vendor.postalZipCode)}}
                    </td>
                </tr>
                <tr>
                    <th class="text-end text-nowrap">Phone</th>
                    <td class="w-65">{{Utils.formatPhoneNumber(vendor.phone)}}</td>
                </tr>
                <tr>
                    <th class="text-end text-nowrap">Max Amount Limit</th>
                    <td class="w-65">{{vendor.maxPreApprovalAmount|currency:'CAD':'symbol-narrow':'1.0'}}</td>
                </tr>
                <tr>
                    <th class="text-end text-nowrap">Max Percentage Limit</th>
                    <td class="w-65">{{vendor.maxPreApprovalPercentage}}</td>
                </tr>                
                </tbody>
                <tbody *ngIf="repairCentre">
                <tr>
                    <th class="text-end text-nowrap">Name</th>
                    <td class="w-65">{{repairCentre.friendlyName ?? repairCentre.name}}</td>
                </tr>
                <tr>
                    <th class="text-end text-nowrap">ID</th>
                    <td class="w-65">{{repairCentre.repairCentreId}}</td>
                </tr>
                <tr>
                    <th class="text-end">Address</th>
                    <td class="w-65">
                        {{repairCentre.address}}<br>
                        {{repairCentre.city}}, {{repairCentre.province}} {{Utils.formatPostalZipCode(repairCentre.postalCode)}}
                    </td>
                </tr>
                <tr>
                    <th class="text-end text-nowrap">Phone</th>
                    <td class="w-65">{{Utils.formatPhoneNumber(repairCentre.phone)}}</td>
                </tr>
                <tr>
                    <th class="text-end text-nowrap">Max Amount Limit</th>
                    <td class="w-65">{{repairCentre.maxPreApprovalAmount}}</td>
                </tr>
                <tr>
                    <th class="text-end text-nowrap">Max Percentage Limit</th>
                    <td class="w-65">{{repairCentre.maxPreApprovalPercentage}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="modal-footer">
    <div class="px-3">
        <button type="button" class="btn btn-secondary me-3" (click)="closeModal()">Cancel</button>
        <button
            class="btn btn-danger position-relative"
            type="button"
            (click)="removeConfiguration()"
            [disabled]="busySaving"
        >
            <span
                class="spinner fade spinner-border spinner-border-sm position-absolute top-0 bottom-0 start-0 end-0 m-auto"
                role="status" 
                aria-hidden="true" 
                [ngClass]="{'show': busySaving}">
                
            </span>
            <span class="text fade show" [ngClass]="{'show': !busySaving}">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash me-1"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                Remove Limits
            </span>
        </button>
    </div>
</div>
